import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=40c2b6a1&scoped=true&"
import script from "./comments.vue?vue&type=script&lang=js&"
export * from "./comments.vue?vue&type=script&lang=js&"
import style0 from "./comments.vue?vue&type=style&index=0&id=40c2b6a1&scoped=true&lang=css&"
import style1 from "./comments.vue?vue&type=style&index=1&id=40c2b6a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c2b6a1",
  null
  
)

export default component.exports